// extracted by mini-css-extract-plugin
export default {"History":"History_History__8aN7L","table":"History_table__OfXc-","year":"History_year__JQEQc","twoh":"History_twoh__tAnyy"};